import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input', 'symbolsLeft']
  static values = {
    maxSymbols: Number,
    description: String
  }

  connect() {
    this.symbolsLeftTarget.textContent = this.maxSymbolsValue;
  }

  onChange(e) {
    let currentSymbolsCount = 0;
    const descriptionTarget = this.inputTarget.childNodes;
    descriptionTarget.forEach(function(item) { 
      if (item.innerHTML) {
        currentSymbolsCount += item.innerHTML.replaceAll("<br>", "").replaceAll("<!--block-->", "").replaceAll("&nbsp;", " ").replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&amp;", "&").length;
      }
    });

    const symbolsLeft = this.maxSymbolsValue - currentSymbolsCount;
    this.descriptionValue = e.target.textContent;
    this.symbolsLeftTarget.textContent = Math.max(symbolsLeft, 0);
    if (symbolsLeft < 0) {
      this.element.classList.add('symbol-limit-exceeded');
      this.element.closest('form').querySelector('input[type=submit').disabled = true;
    } else {
      this.element.classList.remove('symbol-limit-exceeded');
      this.element.closest('form').querySelector('input[type=submit').disabled = false;
    }
  }
}